import { useEffect } from "react";

/**
 * Lightweight SEO hook — updates <title> and <meta name="description">
 * on route mount. No external dep. Search-engine crawlers with JS execution
 * (Googlebot) will pick these up.
 */
export function useSEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }
    // Update Open Graph too
    if (title) {
      let og = document.querySelector('meta[property="og:title"]');
      if (og) og.setAttribute("content", title);
      let tw = document.querySelector('meta[name="twitter:title"]');
      if (tw) tw.setAttribute("content", title);
    }
    if (description) {
      let og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", description);
      let tw = document.querySelector('meta[name="twitter:description"]');
      if (tw) tw.setAttribute("content", description);
    }
  }, [title, description]);
}
